<div class="right_col screen-height u_scrns edit-page analytics-page" role="main">
  <div class="container-fluid analytics-container">
    <header class="analytics-header">
      <div class="title_left">
        <h3>More Analytics</h3>
        <p class="analytics-subtitle">Platform insights for the selected period</p>
      </div>
      <div class="title_right">
        <div class="form-inline pull-right analytics-controls">
          <label class="mr-2">Period</label>
          <select class="form-control" [(ngModel)]="days" (change)="onDaysChange()" aria-label="Select analytics period">
            <option [ngValue]="7">Last 7 days</option>
            <option [ngValue]="30">Last 30 days</option>
            <option [ngValue]="90">Last 90 days</option>
          </select>
        </div>
      </div>
    </header>

    <div class="row" *ngIf="isLoading">
      <div class="col-md-12 text-center py-5">
        <i class="fa fa-spinner fa-spin fa-3x"></i>
      </div>
    </div>

    <div *ngIf="!isLoading">
      <div class="row">
        <div class="col-md-12">
          <div class="x_panel">
            <div class="x_title">
              <h2>Platform Overview</h2>
              <div class="clearfix"></div>
            </div>
            <div class="x_content">
              <div class="row">
                <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12" *ngFor="let card of overviewCards">
                  <div class="tile-stats">
                    <div class="count">{{ card.value }}</div>
                    <h3>{{ card.title }}</h3>
                    <p>{{ card.subtitle }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="x_panel">
            <div class="x_title">
              <h2>Matching Health</h2>
              <div class="clearfix"></div>
            </div>
            <div class="x_content">
              <div class="row">
                <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12" *ngFor="let card of healthCards">
                  <div class="tile-stats">
                    <div class="count">{{ card.value }}</div>
                    <h3>{{ card.title }}</h3>
                    <p>{{ card.subtitle }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="x_panel">
            <div class="x_title">
              <h2>User Experience Signals</h2>
              <div class="clearfix"></div>
            </div>
            <div class="x_content">
              <div class="row">
                <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12" *ngFor="let card of experienceCards">
                  <div class="tile-stats">
                    <div class="count">{{ card.value }}</div>
                    <h3>{{ card.title }}</h3>
                    <p>{{ card.subtitle }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="x_panel">
            <div class="x_title">
              <h2>Pain Points</h2>
              <div class="clearfix"></div>
            </div>
            <div class="x_content">
              <div class="row">
                <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12" *ngFor="let card of painPointCards">
                  <div class="tile-stats">
                    <div class="count">{{ card.value }}</div>
                    <h3>{{ card.title }}</h3>
                    <p>{{ card.subtitle }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
